import React, { Component } from 'react'
import Checkbox from '../../elements/Checkbox';

import asyncRoute from '../../../helpers/hoc/asyncRoute';
import Error from '../error';

const Tooltip = asyncRoute(() => import('../../../components/FormElements/ToolTip'));

export default class CheckboxGroup extends Component {

  render() {
    let { onChange, onBlur, options, setting, submited, touched, error } = this.props;
    const { textKey = 'value', valueKey = 'checked', key } = setting;
    const { labelLayout = 'col-sm-3' } = setting
    return (
      <div className="form-group row">
        {setting.label && <label htmlFor={setting.key} className={`${labelLayout} col-form-label`}>{setting.label}{" "}{(setting.required)?<span className='text-danger'>*</span>:<><br/><span className="small" style={{color:"#1925238a"}}>Optional</span></>}</label>}
        <div className={setting.displayLayout}>
          {options && options.map((option, index) => (
            <Checkbox
              key={index}
              name={option[textKey]}
              value={option[valueKey]}
              onBlur={(e) => {
                onBlur({
                  target: { name: key }
                })
              }}
              onChange={(e) => {
                options.forEach(a => {
                  if (a[textKey] === option[textKey]) {
                    option[valueKey] = e.target.checked;
                  }
                })
                onChange({
                  target: { name: key, value: options }
                })
                onBlur({
                  target: { name: key }
                })
              }}
              disabled={option.disabled}
              hidden={(option.disabled && !option.checked) ? true : false}
            />
          ))}
          {(submited || touched) && (<Error setting={setting} error={error} />)}
        </div>
        {setting.tooltip && <Tooltip text={setting.tooltip} />}
      </div>
    )
  }
}
